module.exports = __webpack_public_path__ + "img/GH-corporate-002.3257d8d5.png";